import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Forms, Loading, Paging, SystemText } from 'e4shared';
import { apiGet } from 'services';
import { Card } from '../shared';

export const KnowledgeBank = ({ allowMultiple, pageSize, onAddItem, noResultsMessage, testId }) => {
    const [questions, setQuestions] = useState([]);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [recordCount, setRecordCount] = useState(0);
    const [competency, setCompetency] = useState(null);
    const [loading, setLoading] = useState(true);

    const guid = useSelector(state => (state.user.user ? state.user.user.guid : ''));
    const competencies = useSelector(state => state.user.downlineCompetencies);
    const competenciesMapped = competencies ? competencies.map(c => ({ id: c.id, name: `${c.area} - ${c.name}` })) : [];

    const getQuestions = useCallback(() => {
        apiGet(
            `question-bank/questions?page=${page || 1}&sort=11&sortdirection=asc&pagesize=${pageSize}&search=${
                search || ''
            }&competency=${competency || 0}`,
            guid,
            response => {
                setQuestions(response?.questions);
                setRecordCount(response?.records);
                setLoading(false);
            }
        );
    }, [guid, competency, page, search]);

    useEffect(() => {
        setPage(1);
    }, [search, competency]);

    useEffect(() => {
        getQuestions();
    }, [guid, page, search, competency, getQuestions]);

    if (loading) return <Loading />;

    return (
        <div data-testid={testId}>
            {Boolean(competenciesMapped?.length) && (
                <>
                    <div>
                        <Forms.Text
                            label={SystemText('Admin/Forms/FilePicker/Content/KnowledgeBank/Filters/Title')}
                            id="search"
                            placeholder={SystemText(
                                'Admin/Forms/FilePicker/Content/KnowledgeBank/Fields/Search/Placeholder'
                            )}
                            value={search}
                            onChange={setSearch}
                            icon="fa-search"
                        />
                    </div>
                    <div className="no-label">
                        <Forms.Select
                            id="competency_Id"
                            placeholder={SystemText(
                                'Admin/Forms/FilePicker/Content/KnowledgeBank/Fields/Competencies/Placeholder'
                            )}
                            data={competenciesMapped}
                            value={competency}
                            onChange={setCompetency}
                        />
                    </div>
                </>
            )}
            {!questions?.length ? (
                <div>{noResultsMessage}</div>
            ) : (
                <>
                    <label>{SystemText('Admin/Forms/FilePicker/Content/KnowledgeBank/Title')}</label>
                    <div className="text-sm mb5">{SystemText('Admin/Forms/FilePicker/Content/KnowledgeBank/SubTitle')}</div>
                    <div className="list">
                        {questions.map(question => (
                            <Card
                                addItemHandler={() => onAddItem(question, allowMultiple)}
                                title={SystemText('Admin/Forms/FilePicker/Content/KnowledgeBank/Card/Title', question.name)}
                                label={question.name}
                                name={question.owner_Full_Name}
                                date={question.created}
                                key={`${question.id}-${question.owner_Id}`}
                            >
                                <div className="kb-icon-holder">
                                    <i className="fa fa-bank fa-3x "></i>
                                </div>
                            </Card>
                        ))}
                    </div>
                    {Boolean(questions?.length) && (
                        <Paging pageSize={pageSize} recordCount={recordCount} page={page} goToPage={page => setPage(page)} />
                    )}
                </>
            )}
        </div>
    );
};

export default KnowledgeBank;
